import React, { useEffect, useState, useMemo } from "react";
import { useBuscarPacientes } from "../../hooks/useBuscarPacientesDebounce";
import {
  Box,
  Typography,
  IconButton,
  Tooltip,
  useTheme,
  Paper,
  Grid,
  Chip,
  Button,
} from "@material-ui/core";
import {
  ChevronLeft,
  ChevronRight,
  Today,
  EventNote,
  PostAdd,
  Delete,
  Edit,
} from "@material-ui/icons";
import { useLocalStorage } from "../../hooks/useLocalStorage";
import moment, { utc } from "moment-timezone";
import "moment/locale/es";
import { registerLocale } from "react-datepicker";
import es from "date-fns/locale/es";
import DatePicker from "react-datepicker";
import { useToasts } from "react-toast-notifications";
import { AutocompletePaciente } from "../Autocomplete-Paciente";
import { savePaciente } from "../../services/firebase/pacientes";
import Gateways from "../../gateways/api";
import Spinner from "react-bootstrap/Spinner";
import "./styles.css";

// Initializations
moment.locale("es");
registerLocale("es", es);

const ISO_DATETIME_FORMAT = "YYYY-MM-DDTHH:mm:ss";


const CitaItem = () => {
  const [citasCalendar, setCitasCalendar] = useState([]);
  const [ajustesHorariosReservada, setAjustesHorariosReservada] = useState({});
  const [duracionCitaMin, setDuracionCitaMin] = useState();
  const [usuario] = useLocalStorage("usuario");
  const [showModal, setShowModal] = useState(false);
  const [showModalReserva, setShowModalReserva] = useState(false);
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [paciente, setPaciente] = useState({});
  const [editedTimeInit, setEditedTimeInit] = useState("");
  const [editedTimeEnd, setEditedTimeEnd] = useState("");
  const [editedDateInit, setEditedDateInit] = useState("");
  const [editedDateEnd, setEditedDateEnd] = useState("");
  const [error, setError] = useState(null);
  const [showModalConfirm, setShowModalConfirm] = useState(false);
  const [eventToDelete, setEventToDelete] = useState(null);
  const { addToast } = useToasts();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    horariosDisponiblesEspecialista();
  }, [usuario]);

  const handleChange = (e) => {
    if (!e || !e.target) return;
    const { name, value } = e.target;
    setPaciente((prevPaciente) => ({
      ...prevPaciente,
      [name]: value,
    }));
  };

  const horariosDisponiblesEspecialista = async () => {
    try {
      if (!usuario?.empresaId) {
        console.log("No hay empresaId disponible en el usuario");
        return;
      }
      const response = await Gateways.cita.getCitas(
        buildCitasParams(),
        usuario.accessToken
      );
      const { citas, duracionPeriodoEntreCitas, duracionCitaMin } =
        response.data;
      setAjustesHorariosReservada(duracionPeriodoEntreCitas);
      setCitasCalendar(citas);
      setDuracionCitaMin(duracionCitaMin);
    } catch (error) {
      console.error("Error durante la consulta:", error);
      setError("Error al consultar a la base de datos");
    }
  };

  const buildCitasParams = () => {
    if (!usuario?.empresaId || !usuario?.id) {
      throw new Error(
        "Datos de usuario inválidos: empresaId y id son requeridos."
      );
    }
    const today = new Date();
    today.setUTCHours(0, 0, 0, 0);
    const oneMonthAgo = new Date(today);
    oneMonthAgo.setMonth(oneMonthAgo.getMonth() - 1);
    return {
      empresaId: usuario.empresaId,
      especialistaId: usuario.id,
      fecha: today,
      ignoreRestrictions: true,
    };
  };

  const createEvent = ({
    id,
    title,
    start,
    end,
    backgroundColor,
    textColor,
    editable,
    extendedProps,
  }) => ({
    id,
    title,
    start: new Date(start),
    end: new Date(end),
    backgroundColor,
    textColor,
    editable,
    extendedProps,
  });

  const TimeZone = moment.tz.guess() || "America/Lima";

  const formatPeruTimeKeepHour = (dateTimeString, timeZone) => {
    if (!dateTimeString) return null;
    const noZone = dateTimeString.replace("Z", "");
    const zone = timeZone || moment.tz.guess() || "America/Lima";
    return moment.tz(noZone, ISO_DATETIME_FORMAT, zone);
  };

  // Convierte el ISO (UTC) al instante en America/Lima
  const toMomentInLima = (isoString, zone = "America/Lima") => {
    if (!isoString) return null;
    return moment.utc(isoString).tz(zone); // ejemplo: "2025-06-21T13:00:00Z" -> 08:00 (Lima)
  };

  const generaAvailability2 = (citas, horarios, duracionCitaMin) => {
    const eventos = [];
    const hoy = moment().startOf("day");

    // 1. Generar eventos para citas existentes
    console.log("citas", citas);
    citas.forEach((cita) => {
      const inicio = toMomentInLima(cita.start.dateTime);
      const fin = toMomentInLima(cita.end.dateTime);

      eventos.push(
        createEvent({
          id: cita.id,
          title: (
            cita.attendees?.name?.split(" ")[0] || "Ocupado"
          ).toUpperCase(),
          start: inicio.toDate(),
          end: fin.toDate(),
          backgroundColor: "RGB(3, 155, 229)",
          textColor: "white",
          editable: false,
          extendedProps: { ...cita, isBlocked: true },
        })
      );
    });

    // 2. Generar slots de disponibilidad basados en los horarios
    Object.keys(horarios).forEach((dia) => {
      const diaIndex = parseInt(dia, 10);
      const horario = horarios[dia];

      let fechaActual = moment().day(diaIndex);

      // Generar slots para las próximas 4 semanas
      for (let i = 0; i < 4; i++) {
        let fechaSlot = fechaActual.clone().add(i, "weeks");

        if (fechaSlot.isBefore(hoy)) continue;

        horario.turnos.forEach((turno) => {
          let inicioTurno = fechaSlot.clone().set({
            hour: parseInt(turno.inicio.split(":")[0], 10),
            minute: parseInt(turno.inicio.split(":")[1], 10),
            second: 0,
          });

          const finTurno = fechaSlot.clone().set({
            hour: parseInt(turno.fin.split(":")[0], 10),
            minute: parseInt(turno.fin.split(":")[1], 10),
            second: 0,
          });

          while (inicioTurno.isBefore(finTurno)) {
            const finSlot = inicioTurno.clone().add(duracionCitaMin, "minutes");

            const slotOcupado = eventos.some(
              (evento) =>
                moment(evento.start).isSame(inicioTurno) ||
                (moment(evento.start).isBefore(finSlot) &&
                  moment(evento.end).isAfter(inicioTurno))
            );

            if (!slotOcupado && finSlot.isSameOrBefore(finTurno)) {
              eventos.push(
                createEvent({
                  id: inicioTurno.format(),
                  title: "Disponible",
                  start: inicioTurno.toDate(),
                  end: finSlot.toDate(),
                  backgroundColor: "RGB(234, 234, 234)",
                  textColor: "black",
                  editable: true,
                  extendedProps: { available: true },
                })
              );
            }

            inicioTurno.add(duracionCitaMin, "minutes");
          }
        });
      }
    });

    return eventos;
  };

  /**
   * Función para generar los eventos de disponibilidad
   * considerando las citas existentes y los horarios configurados.
   * @param {*} eventClickInfo
   */
  const generateAvailabilityx = () => {
    if (!citasCalendar?.length) return [];
    if (
      !ajustesHorariosReservada ||
      !Object.keys(ajustesHorariosReservada).length
    )
      return [];
    if (!duracionCitaMin) return [];
    return generaAvailability2(
      citasCalendar,
      ajustesHorariosReservada,
      duracionCitaMin
    );
  };

  const generateAvailability = () => {
    if (!citasCalendar?.length) return [];

    // Sort appointments by start time to help with any potential logic
    const sortedCites = [...citasCalendar].sort((a, b) =>
      moment(a.start.dateTime).diff(moment(b.start.dateTime))
    );

    const todayStart = moment
      .tz(moment.tz.guess() || "America/Lima")
      .startOf("day");
    const disponibilidadEventos = [];

    sortedCites.forEach((cites) => {
      const startM = toMomentInLima(cites.start.dateTime);
      const endM = toMomentInLima(cites.end.dateTime);

      const isBeforeToday = startM.isBefore(todayStart, "day");
      const isAvailable = Boolean(cites.available);

      if (isBeforeToday && !isAvailable) {
        disponibilidadEventos.push(
          createEvent({
            id: cites?.id ?? cites.start.dateTime,
            title: (
              cites.attendees?.name?.split(" ")[0] || "Ocupado"
            ).toUpperCase(),
            start: startM.toDate(),
            end: endM.toDate(),
            backgroundColor: "RGB(96, 191, 255)",
            textColor: "white",
            editable: false,
            extendedProps: { ...cites, isBlocked: true },
          })
        );
        return;
      }

      disponibilidadEventos.push(
        createEvent({
          id: !isAvailable ? cites?.id ?? startM.valueOf() : startM.valueOf(),
          title: isAvailable
            ? "Disponible"
            : (cites.attendees?.name?.split(" ")[0] || "Ocupado").toUpperCase(),
          start: startM.toDate(),
          end: endM.toDate(),
          backgroundColor: !isAvailable
            ? "RGB(3, 155, 229)"
            : "RGB(234, 234, 234)",
          textColor: !isAvailable ? "white" : "black",
          editable: true,
          extendedProps: cites,
        })
      );
    });

    return disponibilidadEventos;
  };

  const handleDateClick = (eventClickInfo) => {
    setPaciente({});
    const selectedEvent = eventClickInfo.event;
    const isMobile = window.innerWidth <= 768;
    if (selectedEvent.title === "Disponible") {
      setSelectedEvent(selectedEvent);
      setEditedDateInit(selectedEvent.start);
      setEditedDateEnd(selectedEvent.end);
      setEditedTimeInit(
        new Date(
          0,
          0,
          0,
          selectedEvent.start.getHours(),
          selectedEvent.start.getMinutes()
        )
      );
      setEditedTimeEnd(
        new Date(
          0,
          0,
          0,
          selectedEvent.end.getHours(),
          selectedEvent.end.getMinutes()
        )
      );
      setShowModalReserva(true);
    } else {
      // Si está ocupado, abrir directamente el modal de edición
      handleEdit({
        id: selectedEvent.id,
        title: selectedEvent.title,
        extendedProps: selectedEvent.extendedProps
      });
    }
  };

  const closeModalEvent = (e) => {
    if (!e.target.closest(".event-modal")) {
      setShowModal(false);
    }
  };

  const handleSaveAppointment = async () => {
    try {
      setLoading(true);
      if (
        !paciente.nombres ||
        !paciente.telefono ||
        !paciente.numDoc
      ) {
        setLoading(false);
        addToast("Completar todos los campos (Nombre, DNI, Teléfono)", { appearance: "error" });
        return false;
      }
      if (!paciente.id) {
        const { id } = await savePaciente({
          ...paciente,
          empresaId: usuario.empresaId,
        });
        paciente.id = id;
      }
      const citas = mapperEventData();

      console.log("CITAS", citas);

      await saveCita(citas);
      setShowModalReserva(false);
      addToast("Guardado satisfactorio", { appearance: "success" });
      await horariosDisponiblesEspecialista();
    } catch (error) {
      addToast(error.message, { appearance: "error" });
    } finally {
      setLoading(false);
    }
  };

  const saveCita = async (cita) => {
    return await Gateways.cita.saveCitas(cita, usuario.accessToken);
  };

  const handleEditedAppointment = async () => {
    try {
      setLoading(true);
      const startMomentLocal = moment.tz(
        combineDateAndTime(editedDateInit, editedTimeInit),
        TimeZone
      );
      const endMomentLocal = moment.tz(
        combineDateAndTime(editedDateEnd, editedTimeEnd),
        TimeZone
      );

      const utcStart = startMomentLocal.clone().utc().toISOString(); // formato ISO con Z
      const utcEnd = endMomentLocal.clone().utc().toISOString();
      if (!validateTimeDateCites()) {
        setLoading(false);
        return;
      }
      const updatedEvent = {
        ...selectedEvent,
        attendees: mapperEventAttendees(),
        empresaId: usuario.empresaId,
        patientId: paciente.id,
        start: {
          dateTime: utcStart,
          timeZone: "UTC",
          dateTimeTZ: startMomentLocal.format(ISO_DATETIME_FORMAT),
        },
        end: {
          dateTime: utcEnd,
          timeZone: "UTC",
          dateTimeTZ: endMomentLocal.format(ISO_DATETIME_FORMAT),
        },
        updated_at: new Date(),
      };

      console.log("updatedEvent", updatedEvent);

      await Gateways.cita.updateCitas(
        updatedEvent.id,
        updatedEvent.empresaId,
        updatedEvent.patientId,
        updatedEvent,
        usuario.accessToken,
        { ignoreRestrictions: true }
      );
      setShowModalReserva(false);
      addToast("Se actualizó el evento", { appearance: "success" });
      await horariosDisponiblesEspecialista();
    } catch (error) {
      addToast(
        error?.response?.data?.mensaje || "Error al actualizar la cita",
        { appearance: "error" }
      );
    } finally {
      setLoading(false);
    }
  };

  const validateTimeDateCites = () => {
    if (!validateSameDay()) {
      addToast("Las fechas deben ser del mismo día", { appearance: "error" });
      return false;
    }
    if (editedTimeEnd <= editedTimeInit) {
      addToast("La hora seleccionada es inválida", { appearance: "error" });
      return false;
    }
    if (validateAppointmentTime()) {
      addToast("La hora seleccionada se encuentra ocupada", {
        appearance: "error",
      });
      return false;
    }
    return true;
  };

  const combineDateAndTime = (date, time) => {
    if (!date || !time) return null;
    const dateObj = date instanceof Date ? date : new Date(date);
    const timeObj =
      typeof time === "number"
        ? new Date(time)
        : time instanceof Date
          ? time
          : new Date(time);
    if (isNaN(dateObj.getTime()) || isNaN(timeObj.getTime())) return null;
    return new Date(
      dateObj.getFullYear(),
      dateObj.getMonth(),
      dateObj.getDate(),
      timeObj.getHours(),
      timeObj.getMinutes(),
      0,
      0
    );
  };

  const mapperEventData = () => {
    const startMomentLocal = moment.tz(selectedEvent.start, TimeZone);
    const endMomentLocal = startMomentLocal
      .clone()
      .add(Number(duracionCitaMin) || 60, "minutes");

    const utcStart = startMomentLocal.clone().utc().toISOString(); // formato ISO con Z
    const utcEnd = endMomentLocal.clone().utc().toISOString();

    return {
      empresaId: usuario.empresaId,
      summary: "Cita médica",
      description: "Consulta general",
      start: {
        dateTime: utcStart,
        dateTimeTZ: startMomentLocal.format(ISO_DATETIME_FORMAT),
        timeZone: "UTC",
      },
      end: {
        dateTime: utcEnd,
        dateTimeTZ: endMomentLocal.format(ISO_DATETIME_FORMAT),
        timeZone: "UTC",
      },
      attendees: mapperEventAttendees(),
      create_at: new Date(),
      patientId: paciente.id,
      especialistaId: usuario.id,
      reminders: {
        useDefault: false,
        overrides: [
          {
            method: "email",
            minutes: 24 * 60,
          },
        ],
      },
      extendedProperties: {
        private: {
          businessId: usuario.empresaId,
          specialistId: usuario.id,
        },
      },
    };
  };

  const validateSameDay = () => {
    if (!editedDateInit || !editedDateEnd) return true;
    const fechaInicio = editedDateInit.toISOString().split("T")[0];
    const fechaFin = editedDateEnd.toISOString().split("T")[0];
    return fechaInicio === fechaFin;
  };

  const validateAppointmentTime = () => {
    if (!editedTimeInit || !editedTimeEnd) return true;

    const editedStart = combineDateAndTime(editedDateInit, editedTimeInit);
    const editedEnd = combineDateAndTime(editedDateEnd, editedTimeEnd);

    const todayStr = moment(editedDateInit).format("YYYY-MM-DD");

    const citasFiltradas = citasCalendar.filter((cita) => {
      if (!cita.start?.dateTime || !cita.end?.dateTime)
        return false;

      // Ignorar slots de disponibilidad
      if (cita.available) return false;

      const citaDate = toMomentInLima(cita.start.dateTime).format("YYYY-MM-DD");
      return citaDate === todayStr;
    });

    const isOverlapping = citasFiltradas.some((cita) => {
      const citaStart = toMomentInLima(cita.start.dateTime).toDate();
      const citaEnd = toMomentInLima(cita.end.dateTime).toDate();

      // Excluir la cita actual que estamos editando
      const currentId = selectedEvent.id || selectedEvent.extendedProps?.id;
      const citaId = cita.id || cita.start?.dateTime;

      if (currentId && citaId && String(currentId) === String(citaId)) {
        return false;
      }

      return (
        (editedStart >= citaStart && editedStart < citaEnd) ||
        (editedEnd > citaStart && editedEnd <= citaEnd) ||
        (editedStart <= citaStart && editedEnd >= citaEnd)
      );
    });

    return isOverlapping;
  };

  const mapperEventAttendees = () => {
    return {
      patientId: paciente.id || null,
      name: paciente.nombres,
      email: paciente.correo,
      phone: paciente.telefono,
      dni: paciente.numDoc,
    };
  };

  const closeModalReserva = () => {
    setShowModalReserva(false);
  };

  const handleEdit = (event) => {
    if (!event?.extendedProps) return;
    const { start, end, attendees } = event.extendedProps;
    const attendee = attendees;

    const dateTimeInit = toMomentInLima(start.dateTime, start.timeZone);
    const dateTimeEnd = toMomentInLima(end.dateTime, end.timeZone);

    setSelectedEvent({
      ...event.extendedProps,
      id: event.id || event.extendedProps?.id,
      start: dateTimeInit.toDate(),
      end: dateTimeEnd.toDate(),
    });
    setEditedDateInit(dateTimeInit.toDate());
    setEditedDateEnd(dateTimeEnd.toDate());
    setEditedTimeInit(
      new Date(
        0,
        0,
        0,
        dateTimeInit.toDate().getHours(),
        dateTimeInit.toDate().getMinutes()
      )
    );
    setEditedTimeEnd(
      new Date(
        0,
        0,
        0,
        dateTimeEnd.toDate().getHours(),
        dateTimeEnd.toDate().getMinutes()
      )
    );

    if (attendee) {
      setPaciente({
        id: attendee.patientId || "",
        nombres: attendee.name || "",
        correo: attendee.email || "",
        telefono: attendee.phone || "",
        numDoc: attendee.dni || "",
      });
    }
    setShowModalReserva(true);
    setShowModal(false);
  };

  const handleDeleteClick = (event) => {
    setEventToDelete(event);
    setShowModalConfirm(true);
  };

  const handleConfirmDelete = async () => {
    if (!eventToDelete) return;
    try {
      setLoading(true);
      const eventId = eventToDelete.id;
      const empresaId = eventToDelete?.extendedProps?.empresaId || eventToDelete.empresaId;
      const patientId = eventToDelete?.extendedProps?.patientId || eventToDelete.patientId;
      await Gateways.cita.deleteCitas(eventId, empresaId, patientId, usuario.accessToken);
      setShowModalConfirm(false);
      setShowModalReserva(false);
      setEventToDelete(null);
      addToast("Cita eliminada correctamente", { appearance: "success" });
      await horariosDisponiblesEspecialista();
    } catch (error) {
      console.error("Error al eliminar el evento:", error);
      addToast("Error al eliminar la cita", { appearance: "error" });
    } finally {
      setLoading(false);
    }
  };

  const formatEventDate = (start, end) => {
    const optionsDate = { weekday: "long", day: "numeric", month: "long" };
    const optionsTime = { hour: "numeric", minute: "2-digit", hour12: true };
    const formattedDate = new Date(start).toLocaleDateString(
      "es-ES",
      optionsDate
    );
    const formattedStartTime = new Date(start).toLocaleTimeString(
      "es-ES",
      optionsTime
    );
    const formattedEndTime = new Date(end).toLocaleTimeString(
      "es-ES",
      optionsTime
    );

    return `${formattedDate} · ${formattedStartTime} – ${formattedEndTime}`;
  };

  const getTimeZone = () => {
    const timeZone =
      new Intl.DateTimeFormat("es-PE", { timeZoneName: "long" })
        .formatToParts(new Date())
        .find((part) => part.type === "timeZoneName")?.value || "";
    return `(GMT-05:00) ${timeZone.replace("hora estándar", "Hora estándar")}`;
  };

  const handleSelected = (item) => {
    if (item.onSelected) {
      const pacienteSeleccionado = {
        ...item,
        nombres: `${item.nombres} ${item.apellidos || ""}`,
      };
      setPaciente(pacienteSeleccionado);
    } else {
      paciente.nombres = item.nombres;
    }
  };

  const toString = (item) => {
    return `${item.nombres} ${item.apellidos || ""}`;
  };

  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const [currentDate, setCurrentDate] = useState(
    moment() // El día actual
  );
  const [view, setView] = useState(isMobile ? "month" : "week"); // "month", "week" o "day"

  const hours = Array.from({ length: 14 }, (_, i) => i + 8); // 8:00 to 21:00

  // Cálculo de los días a mostrar
  const days = useMemo(() => {
    if (view === "week") {
      const startOfWeek = currentDate.clone().startOf("isoWeek"); // Lunes
      return Array.from({ length: 7 }, (_, i) => startOfWeek.clone().add(i, "days"));
    } else if (view === "month") {
      const startOfMonth = currentDate.clone().startOf("month").startOf("isoWeek");
      const endOfMonth = currentDate.clone().endOf("month").endOf("isoWeek");
      const daysArr = [];
      let day = startOfMonth.clone();
      while (day.isBefore(endOfMonth) || day.isSame(endOfMonth, "day")) {
        daysArr.push(day.clone());
        day.add(1, "day");
      }
      return daysArr;
    } else {
      return [currentDate.clone()];
    }
  }, [currentDate, view]);

  const handlePrev = () => {
    setCurrentDate((prev) => prev.clone().subtract(1, view));
  };

  const handleNext = () => {
    setCurrentDate((prev) => prev.clone().add(1, view));
  };

  const handleToday = () => {
    setCurrentDate(moment());
  };

  const handleViewChange = (event, newView) => {
    if (newView !== null) {
      setView(newView);
    }
  };

  const ModernScheduler = () => {
    const allEvents = generateAvailability();

    // Helper to calculate grid positions (15-min precision = 4 rows per hour)
    const getGridRowRange = (start, end) => {
      const startM = moment(start);
      const endM = moment(end);

      const startHour = startM.hours() + startM.minutes() / 60;
      const endHour = endM.hours() + endM.minutes() / 60;

      const gridStart = Math.floor((startHour - 8) * 4) + 2;
      const gridEnd = Math.floor((endHour - 8) * 4) + 2;

      return `${gridStart} / ${gridEnd}`;
    };

    const getGridColumn = (date) => {
      const dayIndex = days.findIndex((d) => d.isSame(moment(date), "day"));
      return dayIndex + 2;
    };

    if (view === "month") {
      return (
        <Paper elevation={0} className="modern-scheduler-container">
          <Box className="scheduler-header">
            <Box display="flex" alignItems="center">
              <Typography variant="h5" className="month-title">
                {currentDate.format("MMMM YYYY").toUpperCase()}
              </Typography>
              <Box ml={3}>
                <IconButton onClick={handleToday} size="small" title="Hoy">
                  <Today color="primary" />
                </IconButton>
                <IconButton onClick={handlePrev} size="small">
                  <ChevronLeft />
                </IconButton>
                <IconButton onClick={handleNext} size="small">
                  <ChevronRight />
                </IconButton>
              </Box>
            </Box>

            <Box display="flex" className="view-switcher">
              <Button
                size="small"
                variant={view === "month" ? "contained" : "outlined"}
                color={view === "month" ? "primary" : "default"}
                onClick={() => setView("month")}
                style={{ marginRight: 8 }}
              >
                Mes
              </Button>
              <Button
                size="small"
                variant={view === "week" ? "contained" : "outlined"}
                color={view === "week" ? "primary" : "default"}
                onClick={() => setView("week")}
                style={{ marginRight: 8 }}
              >
                Semana
              </Button>
              <Button
                size="small"
                variant={view === "day" ? "contained" : "outlined"}
                color={view === "day" ? "primary" : "default"}
                onClick={() => setView("day")}
              >
                Día
              </Button>
            </Box>
          </Box>

          <div className="scheduler-grid view-month">
            {["Lun", "Mar", "Mie", "Jue", "Vie", "Sab", "Dom"].map((d) => (
              <div key={d} className="grid-header-cell month-header">
                <Typography variant="caption">{d}</Typography>
              </div>
            ))}
            {days.map((day) => {
              const isToday = day.isSame(moment(), "day");
              const isCurrentMonth = day.isSame(currentDate, "month");
              const dayAppointments = allEvents.filter(e => 
                e.title !== "Disponible" && moment(e.start).isSame(day, "day")
              );

              return (
                <div
                  key={day.format()}
                  className={`grid-cell month-cell ${isToday ? "is-today" : ""} ${!isCurrentMonth ? "not-current-month" : ""}`}
                  onClick={() => {
                    setCurrentDate(day);
                    setView("day");
                  }}
                >
                  <Typography className="day-number">{day.format("D")}</Typography>
                  {dayAppointments.length > 0 && (
                    <div className="appointment-indicator">
                      {dayAppointments.length} {dayAppointments.length === 1 ? "cita" : "citas"}
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </Paper>
      );
    }

    return (
      <Paper elevation={0} className="modern-scheduler-container">
        {/* Toolbar */}
        <Box className="scheduler-header">
          <Box display="flex" alignItems="center">
            <Typography variant="h5" className="month-title">
              {view === "week"
                ? currentDate.format("MMMM YYYY").toUpperCase()
                : currentDate.format("D [de] MMMM YYYY").toUpperCase()}
            </Typography>
            <Box ml={3}>
              <IconButton onClick={handleToday} size="small" title="Hoy">
                <Today color="primary" />
              </IconButton>
              <IconButton onClick={handlePrev} size="small">
                <ChevronLeft />
              </IconButton>
              <IconButton onClick={handleNext} size="small">
                <ChevronRight />
              </IconButton>
            </Box>
          </Box>

          <Box display="flex" className="view-switcher">
            <Button
              size="small"
              variant={view === "month" ? "contained" : "outlined"}
              color={view === "month" ? "primary" : "default"}
              onClick={() => setView("month")}
              style={{ marginRight: 8 }}
            >
              Mes
            </Button>
            <Button
              size="small"
              variant={view === "week" ? "contained" : "outlined"}
              color={view === "week" ? "primary" : "default"}
              onClick={() => setView("week")}
              style={{ marginRight: 8 }}
            >
              Semana
            </Button>
            <Button
              size="small"
              variant={view === "day" ? "contained" : "outlined"}
              color={view === "day" ? "primary" : "default"}
              onClick={() => setView("day")}
            >
              Día
            </Button>
          </Box>
        </Box>

        {/* Grid Container */}
        <div
          className={`scheduler-grid view-${view}`}
          style={{ "--num-days": days.length }}
        >
          {/* Header Row */}
          <div className="grid-corner"></div>
          {days.map((day) => (
            <div
              key={day.format()}
              className={`grid-header-cell ${day.isSame(moment(), "day") ? "is-today" : ""
                }`}
              style={{ gridColumn: days.indexOf(day) + 2 }}
            >
              <Typography variant="caption" className="day-name">
                {day.format("ddd").toUpperCase()}
              </Typography>
              <Typography variant="h6" className="day-number">
                {day.format("D")}
              </Typography>
            </div>
          ))}

          {/* Time Labels */}
          {hours.map((hour) => (
            <div key={hour} className="time-label" style={{ gridRow: `${(hour - 8) * 4 + 2} / span 4`, gridColumn: 1 }}>
              <Typography variant="caption">
                {moment({ hour }).format("h a")}
              </Typography>
            </div>
          ))}

          {/* Background Grid Cells for clicking/visual guides */}
          {hours.map((hour) => (
            days.map((day, dIdx) => (
              <div
                key={`${day.format()}-${hour}`}
                className="grid-cell"
                style={{
                  gridRow: `${(hour - 8) * 4 + 2} / span 4`,
                  gridColumn: dIdx + 2
                }}
              ></div>
            ))
          ))}

          {/* Appointments & Availability Slots */}
          {allEvents.map((event, idx) => {
            const isAvailable = event.title === "Disponible";
            const col = getGridColumn(event.start);
            if (col < 2) return null; // Out of view

            return (
              <div
                key={event.id || idx}
                className={`event-card ${isAvailable ? "available" : "occupied"}`}
                style={{
                  gridColumn: col,
                  gridRow: getGridRowRange(event.start, event.end),
                  zIndex: isAvailable ? 1 : 2
                }}
                onClick={(e) => {
                  e.stopPropagation();
                  handleDateClick({
                    event: {
                      id: event.id,
                      title: event.title,
                      startStr: moment(event.start).format(),
                      endStr: moment(event.end).format(),
                      start: event.start,
                      end: event.end,
                      extendedProps: event.extendedProps,
                    },
                    jsEvent: e,
                  });
                }}
              >
                <Typography variant="caption" className="event-title">
                  {event.title}
                </Typography>
                {!isAvailable && (
                  <>
                    <Typography variant="inherit" style={{ fontSize: '9px', display: 'block' }}>
                      {moment(event.start).format("HH:mm")} - {moment(event.end).format("HH:mm")}
                    </Typography>
                    <div className="event-actions">
                      <IconButton
                        size="small"
                        className="action-icon delete-icon"
                        onClick={(e) => {
                          e.stopPropagation();
                          handleDeleteClick(event);
                        }}
                      >
                        <Delete style={{ fontSize: 18 }} />
                      </IconButton>
                    </div>
                  </>
                )}
              </div>
            );
          })}
        </div>
      </Paper>
    );
  };

  if (loading)
    return (
      <Spinner animation="border" role="status">
        <span className="visually-hidden"></span>
      </Spinner>
    );
  return (
    <>
      <div className="cita-item-container" onClick={closeModalEvent}>
        <div className="calendar">
          <ModernScheduler />
        </div>
        {showModalReserva && selectedEvent && (
          <div className="modal" onClick={closeModalReserva}>
            <div className="modal-content xs" onClick={(e) => e.stopPropagation()}>
              <div className="modal-header">
                <div className="header-title">
                  <h4>
                    {" "}
                    {selectedEvent?.empresaId ? "Editar" : ""} Horario para cita
                  </h4>

                </div>
              </div>
              <div className="modal-body">
                <div className="mb-3 p-2 bg-light rounded border d-flex align-items-center justify-content-center" style={{ backgroundColor: '#f8fafc', border: '1px solid #e2e8f0' }}>
                  <EventNote style={{ color: '#0c8de3', marginRight: '8px' }} fontSize="small" />
                  <Typography variant="subtitle2" style={{ fontWeight: 600, color: '#0C234C' }}>
                    {moment(editedDateInit).format("dddd, D [de] MMMM [de] YYYY").toUpperCase()}
                  </Typography>
                </div>
                <div className="format-time-GMT">{getTimeZone()}</div>

                <div className="row g-2 mb-3">
                  <div className="col-6">
                    <label className="form-label" style={{ fontSize: '12px', fontWeight: 600 }}>Hora de Inicio:</label>
                    <DatePicker
                      selected={editedTimeInit}
                      onChange={(date) => {
                        setEditedTimeInit(date);
                      }}
                      showTimeSelect
                      showTimeSelectOnly
                      timeFormat="HH:mm"
                      timeIntervals={duracionCitaMin}
                      timeCaption="Hora"
                      dateFormat="h:mm aa"
                      className="form-control time-picker-custom"
                      locale="es"
                    />
                  </div>
                  <div className="col-6">
                    <label className="form-label" style={{ fontSize: '12px', fontWeight: 600 }}>Hora de fin:</label>
                    <DatePicker
                      selected={editedTimeEnd}
                      onChange={(date) => {
                        setEditedTimeEnd(date);
                      }}
                      showTimeSelect
                      showTimeSelectOnly
                      timeFormat="HH:mm"
                      timeIntervals={duracionCitaMin}
                      timeCaption="Hora"
                      dateFormat="h:mm aa"
                      className="form-control time-picker-custom"
                      locale="es"
                    />
                  </div>
                </div>
                <div className="mb-1">
                  <label className="form-label">Nombre:</label>
                  <AutocompletePaciente
                    useSearchItems={useBuscarPacientes}
                    onSelected={handleSelected}
                    toString={toString}
                    inputValueInitial={paciente?.nombres}
                  ></AutocompletePaciente>
                </div>
                <div className="mb-2">
                  <label className="form-label">DNI:</label>
                  <input
                    name="numDoc"
                    type="text"
                    value={paciente.numDoc}
                    onChange={handleChange}
                    className="form-control"
                    placeholder="Ingrese su DNI"
                  />
                </div>

                <div className="mb-2">
                  <label className="form-label">Teléfono:</label>
                  <input
                    name="telefono"
                    type="tel"
                    value={paciente.telefono}
                    onChange={handleChange}
                    className="form-control"
                    placeholder="Ingrese su teléfono"
                  />
                </div>
              </div>
              <div className="modal-footer">
                <button
                  className="btn btn-secondary"
                  onClick={closeModalReserva}
                >
                  Cerrar
                </button>
                <button
                  className="btn btn-primary"
                  onClick={
                    selectedEvent?.empresaId
                      ? handleEditedAppointment
                      : handleSaveAppointment
                  }
                >
                  {selectedEvent?.empresaId ? "Actualizar" : "Reservar"}
                </button>
              </div>
            </div>
          </div>
        )}

        {/* Modal Confirmación Eliminación */}
        {showModalConfirm && (
          <div className="modal" onClick={() => setShowModalConfirm(false)}>
            <div className="modal-content xs confirm-modal" onClick={(e) => e.stopPropagation()}>
              <div className="modal-header">
                <h4>Confirmar Eliminación</h4>
              </div>
              <div className="modal-body">
                <p>¿Está seguro que desea eliminar esta cita?</p>
                {eventToDelete && (
                  <div className="delete-info">
                    <strong>{eventToDelete.title}</strong><br />
                    <small>{formatEventDate(eventToDelete.start, eventToDelete.end)}</small>
                  </div>
                )}
              </div>
              <div className="modal-footer">
                <button
                  className="btn btn-secondary"
                  onClick={() => setShowModalConfirm(false)}
                >
                  Cancelar
                </button>
                <button
                  className="btn btn-danger"
                  onClick={handleConfirmDelete}
                >
                  Confirmar Eliminación
                </button>
              </div>
            </div>
          </div>
        )}
      </div >
    </>
  );
};

export default CitaItem;
